
import axios from "axios";
import { toast } from 'react-toastify';

export interface IContextPropsModel {
  dialogService?: {
    showConfirm: any;
  };
  notificationService?: {
    notify: any;
  };
}
const ErrorLogging = async (data: any) => {
 

  const payload = {
    "business": "DM",
    "domain": "dm",
    "enviornment": "dev",
    "messageType": data?.messageType,
    "message": data?.message
  };

  const config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `https://dev.eves360.ai:3022/api/v1/log`,
    headers: {
      'X-Tenant-Id': '',
      'X-Application': '',
      'X-User-Id': '',
      'xCorrelationId': ''
    },
    data: payload
  };

  try {
    const response = await axios.request(config);
   
    toast.error(response?.data?.message);

    return response;
  } catch (error) {
    console.error("Error:", error);
  }
};

export default ErrorLogging;
